import breakpoints from '../../../theme/breakpoints'
import redesignedTheme from '../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`
  .collection-title {
    font-family: Graphik;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 100%;
    color: ${redesignedTheme.colors.mineShaft};
    border-bottom: 3px solid ${redesignedTheme.colors.lightBlue};
    padding-bottom: 8px;
    text-transform: capitalize;
  }
  
  .collection-title-container {
    margin-top: 5px;
    margin-bottom: 24px;
    width: 100%;
    box-sizing: border-box;
  }
  
  .category .collection-title-container {
    margin-bottom: 0;
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .collection-title-container, .category-body {
      padding: 0 24px; 
    }
  }  
  
  @media only screen and (max-width: ${breakpoints.sm}px) {
    .collection-title-container, .category-body {
      padding: 0 16px; 
    }
  }
`
